import { type MouseEventHandler, type ReactNode, useEffect, useId } from 'react'
import '@liveblocks/react-tiptap/styles.css'
import '@liveblocks/react-ui/styles.css'
import { toast } from 'sonner'
import { RichText } from '#src/components/RichText.tsx'

export function PlaceholderEditor({
  value,
  onClick,
}: {
  value: string
  onClick: MouseEventHandler<HTMLDivElement>
}): ReactNode {
  const id = useId()

  useEffect(() => {
    return () => {
      toast.dismiss(`loading-editor-${id}`)
    }
  }, [id])

  return (
    <RichText
      value={value}
      className="cursor-text"
      onClick={(e) => {
        toast.loading('Loading editor…', {
          id: `loading-editor-${id}`,
        })
        onClick(e)
      }}
    />
  )
}
